// formatters.js
export function formatDate(timestamp) {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  const parts = date
    .toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
    .split(' ')
  return `${parts[0]}. ${parts[1].replace(',', '')}, ${parts[2]}`
}

export function formatDateWithTime(timestamp) {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
